<template>
    <div class="panel-content">
        <div class="video-container">
            <iframe width="1120" height="630" src="https://www.youtube.com/embed/wFxwvX1is7A" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
